//book-wheelchair-and-accessories

/** Hire a wheelchair costing functionality*/
export default class HawStage3 {
    /** Constructor
     *  @param {HTMLElement} element - The root element
     * */
    constructor(element) {
        this.root = element;
        this.deliveryPriceElement = document.querySelector('[data-delivery-price]');
        this.durationSelector = this.root.querySelector('select[data-duration-select]');

        this.accessories = document.querySelectorAll('[data-additional-accessory]');
        this.selectedAccessories = {};

        this.hireFees = document.querySelector('[data-hire-fees]');
        this.grandTotal = document.querySelector('[data-grand-total]');

        this.postcodeLookup = document.querySelector('.js-postcode-lookup');
        this.deliveryOptions = document.querySelectorAll('.js-radio-wheelchair');
        this.additionalAccessories = document.querySelector('.js-addition-accessories');
        this.formPart2 = document.querySelector('.js-delivery-stage-3-part-2');

        this.handleAdditionalInformationVisibility();

        this.handleDeliveryPriceVisibility(this.deliveryPriceElement);
        this.handleDurationChange(this.durationSelector);
        this.bindEvents();
    }

    /** Handles visibility of additional information based on if there are any radio buttons*/
    handleAdditionalInformationVisibility() {
        this.postcodeLookup.style.display = this.deliveryOptions.length > 0 ? 'none' : 'block';
        this.additionalAccessories.style.display = this.deliveryOptions.length > 0 ? 'none' : 'block';
        if (!this.formPart2) {
            return;
        }
        this.formPart2.style.display = this.deliveryOptions.length > 0 ? 'none' : 'block';
    }

    /** Checks to see if the delivery price needs to be hidden
     *  @param {HTMLElement} element - The element containing the delivery price
     * */
    handleDeliveryPriceVisibility(element) {
        if (!element) {
            return;
        }
        const price = parseFloat(element.getAttribute('data-delivery-price'));

        // No action needed. Price doesn't need to be hidden
        if (price > 0) {
            return;
        }

        // Hide the element as it isn't needed by the UI
        element.className = 'wheelchair-hire-duration__fees--hidden';
    }

    /** Handles week duration of rental being selected
     *  @param {HTMLSelectElement} select - The select element being targeted
     * */
    handleDurationChange(select) {
        this.selectedDuration = parseFloat(select.options[select.selectedIndex].getAttribute('data-duration-option'));
        // Recalculate hire costs
        this.calculatePriceChange();
    }

    /** handles actions based on accessory being selected
     *  @param {HTMLButtonElement} accessory - The accessory button
     * */
    handleAccessorySelection(accessory) {
        const isChecked = accessory.classList.contains('js-accessory-added');
        const price = parseFloat(accessory.getAttribute('data-price-acc-input'));

        // Accessory is being removed
        if (isChecked) {
            // Delete the key value pair from the dictionary
            delete this.selectedAccessories[accessory.id];
            accessory.classList.remove('js-accessory-added');
            accessory.innerText = 'Add';
            this.calculatePriceChange();
            return;
        }

        // Accessory is being added
        this.selectedAccessories[accessory.id] = price;
        accessory.classList.add('js-accessory-added');
        accessory.innerText = 'Remove';
        this.calculatePriceChange();
    }

    /** calculates the price change based on the action * */
    calculatePriceChange() {
        // Grand total = delivery cost + (accessories * duration)
        // Get all the accessory prices
        const prices = Object.values(this.selectedAccessories);

        // Calculate how much the cost of the accessory hire is going to cost
        const totalAccessoryHireCost = prices.reduce((acc, price) => acc + (price * this.selectedDuration), 0);

        // Set the hire fees text. Ensure it renders to 2 decimal places
        this.hireFees.innerText = `Hire Fees: £${totalAccessoryHireCost.toFixed(2)}`;

        const deliveryPrice = parseFloat(this.deliveryPriceElement.getAttribute('data-delivery-price'));
        const finalTotal = deliveryPrice + totalAccessoryHireCost;

        this.grandTotal.innerText = `Grand Total: £${finalTotal.toFixed(2)}`;
    }

    bindEvents() {
        //User selects new duration for equipment booking
        this.durationSelector.addEventListener('change', this.handleDurationChange.bind(this, this.durationSelector));

        for (let i = 0; i < this.accessories.length; i++) {
            this.accessories[i].addEventListener('click', this.handleAccessorySelection.bind(this, this.accessories[i]));
        }

        for (let i = 0; i < this.deliveryOptions.length; i++) {
            this.deliveryOptions[i].addEventListener('change', this.handleDeliveryOptionSelected.bind(this, this.deliveryOptions[i]))
        }
    }

    /** Handles the change of radio buttons
     *  @param {HTMLElement} element - The parent element of the radio button
     * */
    handleDeliveryOptionSelected(element) {
        const input = element.querySelector('input[type=radio]');
        if (this.formPart2.style.display === 'none') {
            this.formPart2.style.display = 'block';
        }

        switch (input.id) {
            case 'delivery':
                this.postcodeLookup.style.display = 'block';
                this.root.classList.add('js-wheelchair-validation', 'js-address-form');
                break;
            case 'pickup':
                this.postcodeLookup.style.display = 'none';
                this.root.classList.remove('js-wheelchair-validation', 'js-address-form');
                break;
        }

        if (this.additionalAccessories.style.display === 'block') {
            return;
        }
        this.additionalAccessories.style.display = 'block';
    }
}